export default function CardsPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-warm-gray">Card catalog has been moved. Check out Events instead.</p>
    </div>
  );
}
